angular.module('tf.services')

    .factory('StatisticsService', ['HttpService','$q',
        function (HttpService, $q) {

            var service = {};

            var from_date = new Date();
            from_date.setDate(from_date.getDate()-30);
            var to_date = new Date();
            var unit = 'day';


            function pickOptions (options){
                var httpOptions = _.chain(options).pick(['from_date','to_date','path', 'project','test','type', 'unit']).value();
                if(httpOptions.from_date){
                    httpOptions.from_date = moment(httpOptions.from_date).format("MM-DD-YY");
                }
                if(httpOptions.to_date){
                    httpOptions.to_date = moment(httpOptions.to_date).format("MM-DD-YY");
                }
                return httpOptions;
            }

            service.folderUsers = function(fid, path, options){
                var defer = $q.defer();
                HttpService.get('statmx/produce/users', _.extend({},pickOptions(options), {fid : fid, path : path})).then(function(res){
                    defer.resolve(res.data);
                });

                return defer.promise;
            };
            service.projectUsers = function (fid, projectId, options) {
                var defer = $q.defer();
                HttpService.get('statmx/produce/users', _.extend({},pickOptions(options) , {fid : fid, pid : projectId})).then(function(res){
                    defer.resolve(res.data);
                });
                return defer.promise;
            };


            service.folderUsage = function (fid, path, options) {
                var defer = $q.defer();
                HttpService.get('statmx/produce/projects',_.extend({},pickOptions(options) , {fid : fid, path : path})).then(function(res){
                    defer.resolve(res.data);
                });
                return defer.promise;
            };

            service.projectUsage = function (fid, projectId, options) {
                var defer = $q.defer();
                HttpService.get('stat/produce/templates',_.extend({},pickOptions(options) , {fid : fid, pid : projectId})).then(function(res){
                    defer.resolve(res.data);
                });
                return defer.promise;
            };

            service.plan = function () {
                var defer = $q.defer();
                HttpService.get('stat/plan').then(function(res){
                    defer.resolve(res.data);
                });
                return defer.promise;
            };

            service.farmerLoad = function (fid, options) {
                options = options || {};
                var defer = $q.defer();
                HttpService.get('statmx/produce/farmer',_.extend({},pickOptions(options) , {fid : fid})).then(function(res){
                    defer.resolve(res.data);
                });

                return defer.promise;
            };

            service.cards = {
                projectProductions : function (fid, id, options) {
                    var defer = $q.defer();
                    HttpService.get('stat/cards/productions/templates', _.extend({}, pickOptions(options), {type: 'produce', fid : fid, pid : id} )).then(function(res){
                        defer.resolve(res.data);
                    });
                    return defer.promise;
                },
                productions : function(fid, path, options){
                    var defer = $q.defer();
                    HttpService.get('statmx/cards/productions', _.extend({}, pickOptions(options), {type: 'produce', fid : fid, path : path})).then(function(res){
                        defer.resolve(res.data);
                    });
                    return defer.promise;
                },
                users : function(fid, path, options){
                    var defer = $q.defer();
                    HttpService.get('stat/cards/totalusers',_.extend({}, pickOptions(options), {type: 'produce', fid : fid, path : path})).then(function(res){
                        defer.resolve(res.data);
                    });
                    return defer.promise;
                }
            };



            return service;
        }])
;
